<template>
  <div v-if="coupons.length">
    <cards
      class="grid-deal"
      v-for="(deal, index) in coupons"
      :key="index"
      @click="cardPopUp()"
    >
      <div class="d-flex">
        <div class="deal-container" >
          <div class="box deal-name">{{ deal.name }}</div>
          <div
            class="box deal-discount"
            v-html="getFormtedDiscount(deal)"
          ></div>
          <div class="box">{{ deal.description }}</div>
        </div>
        <div class="box deal-action" v-if="!isHome && (cart &&  cart.order.length && !(cart.coupon_result && cart.coupon == deal.code) )">
          <n-button
            @click="sendCoupon(deal.code)"
            class="p-2"
            type="primary"
            round
            :style="myTheme.customizeButton"
          >
            <i class="k-icon-ok"></i> {{$t('button.apply')}}
          </n-button>
        </div>
      </div>
    </cards>
  </div>
  <div v-else>
    <empty-data
      :message="$t('empty.deals')"
      image="dino-nodeal"
      text-color="#22223B"
    ></empty-data>
  </div>
</template>
<script>
import { Cards, Button } from "@/components";
import EmptyData from "@/views/components/EmptyData";
import { mapState } from "vuex";
import router from "@/router";
export default {
  name: "deals-items",
  components: {
    Cards,
    [Button.name]: Button,
    EmptyData,
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },
  data() {
    return {
      isHomePage: false,
    };
  },
  props: {
    cart: Object,
    coupons : Array,
    isHome : Boolean
  },
  methods: {
    getFormtedDiscount(deal) {
      return deal.discount_type == 2
        ? `<span class='strong'>${this.$options.filters.currency(deal.discount)}</span> 
        ${this.$t("message.coupon_off_orders")} 
        <span class='strong'>${this.$options.filters.currency(deal.minimum_total)}</span>`
        : `<span class='strong'>${parseFloat(
            deal.discount
          ).toString()}%</span> ${this.$t("message.coupon_off_orders")} <span class='strong'>${
            this.$options.filters.currency(deal.minimum_total)
          }</span>`;
    },
    sendCoupon(code) {
      this.$root.$emit("PUSH_COUPON", code);
    },

    cardPopUp() {
      if (!this.user) {
        let message = this.$t("message.login_to_apply_coupon");
        let options = {
          html: true, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
          okText: this.$t("button.go_to_login"),
          cancelText: this.$t("button.cancel"),
          animation: "fade", // Available: "zoom", "bounce", "fade"
          type: "basic", // coming soon: 'soft', 'hard'
          backdropClose: false, // set to true to close the dialog when clicking outside of the dialog window, i.e. click landing on the mask
          customClass: "confirm", // Custom class to be injected into the parent node for the current dialog instance
        };
        this.$dialog
          .confirm(message, options)
          .then(function() {
            router.push({ name: "login", query: { redirect: "/menu" } });
          })
          .catch(() => {});
        return;
      }
    },
  }
};
</script>
